module.exports = __webpack_public_path__ + "fonts/Chivo-Light.d29981b.woff2";